import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { motion } from "framer-motion";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import CTA from "@/components/sections/CTA";
import { FAQ_ITEMS } from "@/lib/content";

export default function FAQ({ onOpenPalette }: { onOpenPalette: () => void }) {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <>
      <Navbar onOpenPalette={onOpenPalette} />
      <main className="pt-28 pb-12 page-fade" data-testid="faq-page">
        <div className="container-edx pt-16 max-w-3xl">
          <div className="section-index">EDX.01</div>
          <h1 className="display mt-4 text-4xl md:text-6xl text-white">Frequently asked <span className="gradient-text">questions</span>.</h1>
          <p className="mt-4 text-edx-muted">Can't find the answer? Ask NOVA (bottom right) or message us on WhatsApp.</p>
          <div className="mt-12 space-y-3">
            {FAQ_ITEMS.map((f, i) => (
              <div key={i} data-testid={`faq-item-${i}`} className="glass p-5 cursor-pointer" onClick={() => setOpen(open === i ? null : i)}>
                <div className="flex items-center justify-between gap-4">
                  <h3 className="display font-semibold text-white text-sm md:text-base">{f.q}</h3>
                  {open === i ? <ChevronUp size={16} className="text-edx-cyan" /> : <ChevronDown size={16} className="text-edx-muted" />}
                </div>
                {open === i && (
                  <motion.p initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }}
                    className="mt-3 text-sm text-edx-muted leading-relaxed">{f.a}</motion.p>
                )}
              </div>
            ))}
          </div>
        </div>
        <CTA />
      </main>
      <Footer />
    </>
  );
}
